// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__diA2r","fullWidth":"Card_fullWidth__eAAsr","header":"Card_header__ggx87"};